import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from "keycloak-angular";
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { IonModal } from '@ionic/angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, finalize, of, timeout } from 'rxjs';

@Component({
  selector: 'app-bfooldal',
  templateUrl: './bfooldal.component.html',
  styleUrls: ['./bfooldal.component.scss'],
})
export class bFooldalComponent implements OnInit {

  feljegyzesek = []
  user$
  loginMode
  userMetadata
  uuid
  @ViewChild('feljegyzesmodal') feljegyzesmodal: IonModal;
  f
  sajatIntezmeny

  constructor(public oauth: OAuthService, private data: DataService, private http: HttpClient) { }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims()) as any;
    this.loginMode = await this.data.getFromStorage("loginmode")
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))

    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    //this.userMetadata.department = "rendszergazda"
    this.uuid = this.user$.username
    if (this.loginMode == "dolgozo") {
      await this.data.showLoading("Ügyfelek betöltése...")
      this.http
        .get(
          '/api/ugyfelek?intezmeny=' + encodeURIComponent(this.sajatIntezmeny.intezmenyId)
        )
        .subscribe({
          next: async (response: any) => {
            this.feljegyzesek = response;
            await this.data.hideLoading()
          },
          error: async () => {
            await this.data.hideLoading()
          },
        });
    }

  }

  close() {
    this.feljegyzesmodal.dismiss()
  }
  async openFeljegyzes(f) {
    await this.data.showLoading("Váltás a könyvelt cégre...")
    try {
      await this.data.setStorage("kivceg",f)
      window.location.replace("/b/bank")
    } finally { this.data.hideLoading() }
    /*console.log(f)
    this.f = f
    this.feljegyzesmodal.present()*/
  }

}
